import { render, staticRenderFns } from "./Recaudacionv4.vue?vue&type=template&id=5ab31272"
import script from "./Recaudacionv4.vue?vue&type=script&lang=js"
export * from "./Recaudacionv4.vue?vue&type=script&lang=js"
import style0 from "./Recaudacionv4.vue?vue&type=style&index=0&id=5ab31272&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports